<div class="feedbacks-container">
  <!-- Bloc Positif -->
  <div class="feedback-group positive-group">
  <div class="feedback-section">
    <div class="section-header">
      <h4>{{ 'satisfaction.feedbacksCards.positiveHeading' | translate }}</h4>
      <span class="column-count">{{ getFeedbacksByStatus('positive').length }}</span>
    </div>

    <div *ngFor="let feedback of getFeedbacksByStatus('positive')" 
         class="message-item nouveau-message" 
         [class.unread]="!isRead(feedback.feedback_id)"
         [class.read]="isRead(feedback.feedback_id)"
         (click)="onCardClick(feedback)">
      <div class="message-header">
        <div class="header-ligne-1">
          <div class="header-ligne-1-left">
            <span class="message-site" *ngIf="feedback.establishment_name">{{ feedback.establishment_name }}</span>
            <span class="message-time">{{ formatDate(feedback.created_at) }}</span>
          </div>
          <button class="btn-archive-inline" (click)="$event.stopPropagation(); confirmArchiveFeedback(feedback)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="21,8 21,21 3,21 3,8"/>
              <rect x="1" y="3" width="22" height="5"/>
              <line x1="10" y1="12" x2="14" y2="12"/>
            </svg>
          </button>
        </div>
        <div class="header-ligne-2">
          <span class="feedback-id">#{{ getShortId(feedback.feedback_id) }}</span>
          <span class="rating">{{ '⭐'.repeat(feedback.score || 0) }}</span>
        </div>
        <div class="header-ligne-3" *ngIf="feedback.queue_name">
          <span class="queue-label">{{ 'satisfaction.feedbacksCards.queueLabel' | translate }}</span>
          <span class="queue-name">{{ feedback.queue_name }}</span>
        </div>
      </div>
      <div class="message-content">
        <p class="message-texte">{{ feedback.comment || 'satisfaction.common.noComment' | translate }}</p>
        <div class="feedback-details">
          <div class="detail-item" *ngIf="feedback.wants_reply">
            <span class="detail-label">{{ 'satisfaction.feedbacksCards.wantsReplyLabel' | translate }}</span> {{ 'common.actions.yes' | translate }}
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ 'satisfaction.feedbacksCards.waitPerceptionLabel' | translate }}</span> <span class="wait-time-badge wait-{{ getWaitTimeClass(feedback.reported_bucket) }}">{{ getBucketLabel(feedback.reported_bucket) }}</span>
          </div>
          <ng-container *ngIf="feedback.form_responses?.length">
            <div class="form-responses-separator"></div>
            <div class="detail-item form-response-item" *ngFor="let r of feedback.form_responses">
              <span class="detail-label">{{ r.question_text }}</span>
              <span class="form-rating">{{ getRatingLabel(r.rating) }}</span>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="message-actions">
        <button class="btn-commentaires" *ngIf="feedback.wants_reply" (click)="openReplyModal.emit(feedback)">
          {{ 'satisfaction.common.replyByEmailButton' | translate }}
        </button>
        <!-- DEPRECATED (2026-09-08) : bouton/badge action corrective retirés avec la fonctionnalité
             -- voir la note en tête de satisfaction.component.ts.
        <button class="btn-commentaires" *ngIf="!feedback.has_corrective_action" (click)="createAction.emit(feedback)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
          </svg>
          {{ 'satisfaction.common.actionButton' | translate }}
        </button>
        <span class="action-indicator" *ngIf="feedback.has_corrective_action">
          {{ 'satisfaction.common.actionCreatedBadge' | translate }}
        </span>
        -->
        <div class="status-buttons">
        </div>
      </div>
    </div>
  </div>
  </div>

  <!-- Bloc Négatif + Réclamation -->
  <div class="feedback-group negative-group">
  <div class="feedback-section">
    <div class="section-header">
      <h4>{{ 'satisfaction.feedbacksCards.negativeHeading' | translate }}</h4>
      <span class="column-count">{{ getFeedbacksByStatus('negative').length }}</span>
    </div>

    <div *ngFor="let feedback of getFeedbacksByStatus('negative')" 
         class="message-item ia-message"
         [class.unread-negative]="!isRead(feedback.feedback_id)"
         [class.read]="isRead(feedback.feedback_id)"
         (click)="onCardClick(feedback)">
      <div class="message-header">
        <div class="header-ligne-1">
          <div class="header-ligne-1-left">
            <span class="message-site" *ngIf="feedback.establishment_name">{{ feedback.establishment_name }}</span>
            <span class="message-time">{{ formatDate(feedback.created_at) }}</span>
          </div>
          <button class="btn-archive-inline" (click)="$event.stopPropagation(); confirmArchiveFeedback(feedback)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="21,8 21,21 3,21 3,8"/>
              <rect x="1" y="3" width="22" height="5"/>
              <line x1="10" y1="12" x2="14" y2="12"/>
            </svg>
          </button>
        </div>
        <div class="header-ligne-2">
          <span class="feedback-id">#{{ getShortId(feedback.feedback_id) }}</span>
          <span class="rating">{{ '⭐'.repeat(feedback.score || 0) }}</span>
        </div>
        <div class="header-ligne-3" *ngIf="feedback.queue_name">
          <span class="queue-label">{{ 'satisfaction.feedbacksCards.queueLabel' | translate }}</span>
          <span class="queue-name">{{ feedback.queue_name }}</span>
        </div>
      </div>
      <div class="message-content">
        <p class="message-texte">{{ feedback.comment || 'satisfaction.common.noComment' | translate }}</p>
        <div class="feedback-details">
          <div class="detail-item" *ngIf="feedback.wants_reply">
            <span class="detail-label">{{ 'satisfaction.feedbacksCards.wantsReplyLabel' | translate }}</span> {{ 'common.actions.yes' | translate }}
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ 'satisfaction.feedbacksCards.waitPerceptionLabel' | translate }}</span> <span class="wait-time-badge wait-{{ getWaitTimeClass(feedback.reported_bucket) }}">{{ getBucketLabel(feedback.reported_bucket) }}</span>
          </div>
          <ng-container *ngIf="feedback.form_responses?.length">
            <div class="form-responses-separator"></div>
            <div class="detail-item form-response-item" *ngFor="let r of feedback.form_responses">
              <span class="detail-label">{{ r.question_text }}</span>
              <span class="form-rating">{{ getRatingLabel(r.rating) }}</span>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="message-actions">
        <button class="btn-commentaires" *ngIf="feedback.wants_reply" (click)="openReplyModal.emit(feedback)">
          {{ 'satisfaction.common.replyByEmailButton' | translate }}
        </button>
        <!-- DEPRECATED (2026-09-08) : bouton/badge action corrective retirés avec la fonctionnalité
             -- voir la note en tête de satisfaction.component.ts.
        <button class="btn-commentaires" *ngIf="!feedback.has_corrective_action" (click)="createAction.emit(feedback)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
          </svg>
          {{ 'satisfaction.common.actionButton' | translate }}
        </button>
        <span class="action-indicator" *ngIf="feedback.has_corrective_action">
          {{ 'satisfaction.common.actionCreatedBadge' | translate }}
        </span>
        -->
        <div class="status-buttons">
        </div>
      </div>
    </div>
  </div>

  <div class="feedback-section">
    <div class="section-header">
      <h4>{{ 'satisfaction.feedbacksCards.repliesRequestedHeading' | translate }}</h4>
      <div class="header-actions">
        <button class="btn-bulk-reply" *ngIf="showBulkSelection" (click)="openBulkReplyModal()">
          {{ 'satisfaction.feedbacksCards.replyByEmailCountButton' | translate: { count: getSelectedComplaintsCount() } }}
        </button>
        <input type="checkbox" id="bulk-reply-checkbox" (change)="toggleBulkReply($event)">
        <span class="column-count">{{ getFeedbacksByStatus('complaint').length }}</span>
      </div>
    </div>

    <ng-container *ngFor="let feedback of getFeedbacksByStatus('complaint')">
    <div *ngIf="!showBulkSelection || (feedback.wants_reply && feedback.contact_email && !feedback.replied_at)"
         class="message-item ia-message"
         [class.read]="isRead(feedback.feedback_id)"
         (click)="onCardClick(feedback)">
      <input type="checkbox" *ngIf="showBulkSelection && feedback.wants_reply && feedback.contact_email"
             [checked]="selectedFeedbacks.has(feedback.feedback_id)"
             (change)="toggleFeedbackSelection(feedback.feedback_id, $event)"
             class="bulk-checkbox">
      <div class="message-header">
        <div class="header-ligne-1">
          <div class="header-ligne-1-left">
            <span class="message-site" *ngIf="feedback.establishment_name">{{ feedback.establishment_name }}</span>
            <span class="message-time">{{ formatDate(feedback.created_at) }}</span>
          </div>
          <button class="btn-archive-inline" *ngIf="feedback.replied_at" (click)="$event.stopPropagation(); confirmArchiveFeedback(feedback)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="21,8 21,21 3,21 3,8"/>
              <rect x="1" y="3" width="22" height="5"/>
              <line x1="10" y1="12" x2="14" y2="12"/>
            </svg>
          </button>
        </div>
        <div class="header-ligne-2">
          <span class="feedback-id">#{{ getShortId(feedback.feedback_id) }}</span>
          <span class="rating">{{ '⭐'.repeat(feedback.score || 0) }}</span>
        </div>
        <div class="header-ligne-3" *ngIf="feedback.queue_name">
          <span class="queue-label">{{ 'satisfaction.feedbacksCards.queueLabel' | translate }}</span>
          <span class="queue-name">{{ feedback.queue_name }}</span>
        </div>
      </div>
      <div class="message-content">
        <p class="message-texte">{{ feedback.comment || 'satisfaction.common.noComment' | translate }}</p>
        <div class="feedback-details">
          <div class="detail-item">
            <span class="detail-label">{{ 'satisfaction.feedbacksCards.waitPerceptionLabel' | translate }}</span> <span class="wait-time-badge wait-{{ getWaitTimeClass(feedback.reported_bucket) }}">{{ getBucketLabel(feedback.reported_bucket) }}</span>
          </div>
          <ng-container *ngIf="feedback.form_responses?.length">
            <div class="form-responses-separator"></div>
            <div class="detail-item form-response-item" *ngFor="let r of feedback.form_responses">
              <span class="detail-label">{{ r.question_text }}</span>
              <span class="form-rating">{{ getRatingLabel(r.rating) }}</span>
            </div>
          </ng-container>
          <div class="detail-item" *ngIf="feedback.replied_at">
            <span class="detail-label">{{ 'satisfaction.feedbacksCards.repliedOnLabel' | translate }}</span> {{ formatDate(feedback.replied_at) }}
          </div>
          <div class="detail-item" *ngIf="feedback.replied_at && feedback.replied_by_name">
            <span class="detail-label">{{ 'satisfaction.feedbacksCards.agentLabel' | translate }}</span> {{ formatAgentName(feedback.replied_by_name) }}
          </div>
        </div>
      </div>
      <div class="message-actions">
        <button class="btn-commentaires btn-with-badge" (click)="feedback.contact_email ? openReplyModal.emit(feedback) : openCallModal.emit(feedback)">
          <svg *ngIf="feedback.contact_email" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
          <span *ngIf="!feedback.contact_email">📞</span>
          <span class="badge-check" *ngIf="feedback.replied_at && feedback.contact_method !== 'CLOSED_WITHOUT_CONTACT'">✓</span>
          <span class="badge-check badge-closed" *ngIf="feedback.replied_at && feedback.contact_method === 'CLOSED_WITHOUT_CONTACT'">×</span>
        </button>
        <!-- DEPRECATED (2026-09-08) : bouton/badge action corrective retirés avec la fonctionnalité
             -- voir la note en tête de satisfaction.component.ts.
        <button class="btn-commentaires" *ngIf="!feedback.has_corrective_action" (click)="createAction.emit(feedback)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
          </svg>
          {{ 'satisfaction.common.actionButton' | translate }}
        </button>
        <span class="action-indicator" *ngIf="feedback.has_corrective_action">
          {{ 'satisfaction.common.actionCreatedBadge' | translate }}
        </span>
        -->
        <div class="status-buttons">
        </div>
      </div>
    </div>
    </ng-container>
  </div>
  </div>

  <!-- DEPRECATED (2026-09-08) : 4e groupe "Actions" (avis avec action corrective) retiré --
       ces avis se classent désormais dans positif/négatif/réclamation comme les autres, voir la
       note en tête de satisfaction.component.ts et de feedbacks-cards.component.ts.
  <div class="feedback-group treated-group">
  <div class="feedback-section treated-section">
    <div class="section-header">
      <h4>{{ 'satisfaction.feedbacksCards.actionsHeading' | translate }}</h4>
      <span class="column-count">{{ getFeedbacksByStatus('treated').length }}</span>
    </div>

    <div class="column-content">
      <ng-container *ngFor="let feedback of getFeedbacksByStatus('treated')">
      <div *ngIf="!showBulkSelection || (feedback.contact_email && !feedback.replied_at)"
           class="message-item read"
           [class.treated-positive]="(feedback.score || 0) >= 3"
           [class.treated-negative]="(feedback.score || 0) <= 2"
           [class.highlight-animation]="highlightedFeedbackId() === feedback.feedback_id">
        <input type="checkbox" *ngIf="showBulkSelection && feedback.contact_email"
               [checked]="selectedFeedbacks.has(feedback.feedback_id)"
               (change)="toggleFeedbackSelection(feedback.feedback_id, $event)"
               class="bulk-checkbox">
        <div class="message-header">
          <div class="header-ligne-1">
            <div class="header-ligne-1-left">
              <span class="message-site" *ngIf="feedback.establishment_name">{{ feedback.establishment_name }}</span>
              <span class="message-time">{{ formatDate(feedback.created_at) }}</span>
            </div>
            <button class="btn-archive-inline" *ngIf="feedback.corrective_action_status === 'completed'" (click)="$event.stopPropagation(); confirmArchiveFeedback(feedback)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="21,8 21,21 3,21 3,8"/>
                <rect x="1" y="3" width="22" height="5"/>
                <line x1="10" y1="12" x2="14" y2="12"/>
              </svg>
            </button>
          </div>
          <div class="header-ligne-2">
            <span class="feedback-id">#{{ getShortId(feedback.feedback_id) }}</span>
            <span class="rating">{{ '⭐'.repeat(feedback.score || 0) }}</span>
          </div>
          <div class="header-ligne-3" *ngIf="feedback.queue_name">
            <span class="queue-label">{{ 'satisfaction.feedbacksCards.queueLabel' | translate }}</span>
            <span class="queue-name">{{ feedback.queue_name }}</span>
          </div>
        </div>
        <div class="message-content">
          <p class="message-texte">{{ feedback.comment || 'satisfaction.common.noComment' | translate }}</p>
          <div class="feedback-details">
            <div class="detail-item">
              <span class="detail-label">{{ 'satisfaction.feedbacksCards.waitPerceptionLabel' | translate }}</span> <span class="wait-time-badge wait-{{ getWaitTimeClass(feedback.reported_bucket) }}">{{ getBucketLabel(feedback.reported_bucket) }}</span>
            </div>
            <ng-container *ngIf="feedback.form_responses?.length">
              <div class="form-responses-separator"></div>
              <div class="detail-item form-response-item" *ngFor="let r of feedback.form_responses">
                <span class="detail-label">{{ r.question_text }}</span>
                <span class="form-rating">{{ getRatingLabel(r.rating) }}</span>
              </div>
            </ng-container>
            <div class="detail-item" *ngIf="feedback.corrective_action_created_at">
              <span class="detail-label">{{ 'satisfaction.feedbacksCards.actionCreatedOnLabel' | translate }}</span> {{ formatDate(feedback.corrective_action_created_at) }}
            </div>
            <div class="detail-item" *ngIf="feedback.has_corrective_action">
              <span class="detail-label">{{ 'satisfaction.feedbacksCards.agentLabel' | translate }}</span> {{ formatAgentName(feedback.corrective_action_assigned_to) }}
            </div>
            <div class="detail-item detail-item-with-status" *ngIf="feedback.has_corrective_action">
              <span class="detail-label">{{ 'satisfaction.feedbacksCards.statusLabel' | translate }}</span>
              <span class="action-indicator-inline" (click)="$event.stopPropagation(); viewAction.emit(feedback)" [class.status-pending]="feedback.corrective_action_status === 'pending'" [class.status-in-progress]="feedback.corrective_action_status === 'in_progress'" [class.status-completed]="feedback.corrective_action_status === 'completed'">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle *ngIf="feedback.corrective_action_status === 'pending'" cx="12" cy="12" r="10"/>
                  <path *ngIf="feedback.corrective_action_status === 'pending'" d="M12 6v6l4 2"/>
                  <path *ngIf="feedback.corrective_action_status === 'in_progress'" d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83"/>
                  <path *ngIf="feedback.corrective_action_status === 'completed'" d="M9 11l3 3L22 4"/>
                  <path *ngIf="feedback.corrective_action_status === 'completed'" d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                </svg>
                {{ (feedback.corrective_action_status === 'pending' ? 'satisfaction.common.status.toTreat' : feedback.corrective_action_status === 'in_progress' ? 'satisfaction.common.status.inProgress' : 'satisfaction.common.status.completed') | translate }}
              </span>
            </div>
          </div>
        </div>
        <div class="message-actions">
          <button class="btn-commentaires btn-with-badge" *ngIf="feedback.contact_email || feedback.contact_tel" (click)="$event.stopPropagation(); feedback.contact_email ? openReplyModal.emit(feedback) : openCallModal.emit(feedback)">
            <svg *ngIf="feedback.contact_email" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            <span *ngIf="!feedback.contact_email">📞</span>
            <span class="badge-check" *ngIf="feedback.replied_at && feedback.contact_method !== 'CLOSED_WITHOUT_CONTACT'">✓</span>
            <span class="badge-check badge-closed" *ngIf="feedback.replied_at && feedback.contact_method === 'CLOSED_WITHOUT_CONTACT'">×</span>
          </button>
          <button class="btn-commentaires" *ngIf="feedback.has_corrective_action" (click)="$event.stopPropagation(); viewAction.emit(feedback)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
            {{ 'satisfaction.common.actionButton' | translate }}
          </button>
          <button class="btn-commentaires" *ngIf="!feedback.has_corrective_action" (click)="$event.stopPropagation(); createAction.emit(feedback)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
            {{ 'satisfaction.common.actionButton' | translate }}
          </button>
        </div>
      </div>
      </ng-container>
    </div>
  </div>
  </div>
  -->
</div>

<!-- Popup de confirmation d'archivage -->
<div class="modal-overlay" *ngIf="showArchiveConfirm" (click)="cancelArchive()">
  <div class="confirmation-modal" (click)="$event.stopPropagation()">
    <h3>{{ 'satisfaction.feedbacksCards.archiveConfirmTitle' | translate }}</h3>
    <p>{{ 'satisfaction.feedbacksCards.archiveWarning' | translate }}</p>
    <div class="confirmation-actions">
      <button class="btn-cancel" (click)="cancelArchive()">{{ 'common.actions.cancel' | translate }}</button>
      <button class="btn-confirm" (click)="executeArchive()">{{ 'satisfaction.common.archive' | translate }}</button>
    </div>
  </div>
</div>
